import { render, staticRenderFns } from "./medium.vue?vue&type=template&id=0c127e4b&scoped=true&"
import script from "./medium.vue?vue&type=script&lang=js&"
export * from "./medium.vue?vue&type=script&lang=js&"
import style0 from "./medium.vue?vue&type=style&index=0&id=0c127e4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c127e4b",
  null
  
)

export default component.exports